import {
    Card as MuiCard, CardContent as MuiCardContent,
    CardHeader as MuiCardHeader,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Theme,
    withStyles
} from "@material-ui/core";
import React, {FC, useEffect, useState} from "react";
import styled from "styled-components/macro";
import {spacing} from "@material-ui/system";
import {Clp} from "../../../../../models/Clp";
import NoDataAvailable from "../../../statistic/components/widgets/components/NoDataAvailable";


const Card = styled(MuiCard)(spacing);
const CardContent = withStyles((theme: Theme) => ({
    root: {
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            alignItems: "flex-start",
            flexDirection: "column"
        },
        padding: "16px !important"
    }
}))(MuiCardContent);
const CardHeader = withStyles((theme: Theme) => ({
    root: {
        paddingBottom: "0 !important"
    }
}))(MuiCardHeader);

function createData(
    name: string,
    x1: string | number,
    x2: string | number,
    x3: string | number,
    x4: string | number,
    x5: string | number
) {
    return { name, x1, x2, x3, x4, x5 };
}

type PropsType = {
    data: Clp[] | null
}

const TypeIssuesWidget: FC<PropsType> = ({ data }) => {
    const [rows, setRows] = useState<any[]>([])

    const getPriceCounts = (data: Clp[]) => {
        return data.reduce((acc, obj) => {
            const priority = obj.price_level;
            const price = obj.price;
            // @ts-ignore
            acc[priority] = (acc[priority] || 0) + price;
            return acc;
        }, {1: 0, 2: 0, 3: 0, 4: 0, 5: 0});
    }

    useEffect(() => {
        if (data && data.length > 0) {
            const priorityCounts = data.reduce((acc, obj) => {
                const priority = obj.price_level ? obj.price_level : 0;
                // @ts-ignore
                acc[priority] = (acc[priority] || 0) + 1;
                return acc;
            }, {1: 0, 2: 0, 3: 0, 4: 0, 5: 0});
            const priceCounts = getPriceCounts(data)
            const mandatoryCounts = getPriceCounts(data.filter((i) => i.is_mandatory))
            const recommendedCounts = getPriceCounts(data.filter((i) => !i.is_mandatory))

            setRows([
                createData('Cost level', 1, 2, 3, 4, 5),
                createData('Number of issues', priorityCounts[1], priorityCounts[2], priorityCounts[3], priorityCounts[4], priorityCounts[5]),
                createData(
                    'Mandatory',
                    `${mandatoryCounts[1].toLocaleString()}€`,
                    `${mandatoryCounts[2].toLocaleString()}€`,
                    `${mandatoryCounts[3].toLocaleString()}€`,
                    `${mandatoryCounts[4].toLocaleString()}€`,
                    `${mandatoryCounts[5].toLocaleString()}€`
                ),
                createData(
                    'Recommended',
                    `${recommendedCounts[1].toLocaleString()}€`,
                    `${recommendedCounts[2].toLocaleString()}€`,
                    `${recommendedCounts[3].toLocaleString()}€`,
                    `${recommendedCounts[4].toLocaleString()}€`,
                    `${recommendedCounts[5].toLocaleString()}€`
                ),
                createData(
                    'Rough cost estimate',
                    `${priceCounts[1].toLocaleString()}€`,
                    `${priceCounts[2].toLocaleString()}€`,
                    `${priceCounts[3].toLocaleString()}€`,
                    `${priceCounts[4].toLocaleString()}€`,
                    `${priceCounts[5].toLocaleString()}€`
                ),
            ])
        }
    }, [data]);

    return (
        <Card style={{height: '100%', position: 'relative'}}>
            <CardHeader title={'Types of issues'}/>
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell align="center">{'< 20€'}</TableCell>
                                <TableCell align="center">{'< 100€'}</TableCell>
                                <TableCell align="center">{'< 1 000€'}</TableCell>
                                <TableCell align="center">{'< 10 000€'}</TableCell>
                                <TableCell align="center">{'> 10 000€'}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.length > 0 ? rows.map((row) => (
                                <TableRow key={row.name}>
                                    <TableCell scope="row">{row.name}</TableCell>
                                    <TableCell align="center">{row.x1}</TableCell>
                                    <TableCell align="center">{row.x2}</TableCell>
                                    <TableCell align="center">{row.x3}</TableCell>
                                    <TableCell align="center">{row.x4}</TableCell>
                                    <TableCell align="center">{row.x5}</TableCell>
                                </TableRow>
                            )) : null}
                        </TableBody>
                    </Table>
                </TableContainer>
                <NoDataAvailable visible={!!(data && data.length === 0)}/>
            </CardContent>
        </Card>
    )
}

export default TypeIssuesWidget